import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import Wrapper from '../components/Wrapper'
import Photo from './image'
import Photo2 from './image2'

export default () => (
  <Wrapper>
    {/* <H2 className="center">2026 ALAIR Conference</H2> */}
    <IMGdiv>
      {/* <Photo /> */}
      <ImgText>
        <img 
          src="/assets/ALAIR-2026-Group-Photo.jpg"
          alt="ALAIR 2026 Convention"
          style={{ width: '100%', height: 'auto' }}
        />
        <p>
          Thank you for coming to the 2026 ALAIR Conference at Southern Union State Community College in Opelika, Alabama! We had a great time and we hope to see you next year.
        </p>
        {/* <Paper>
          <h3>
            <a href="/forms/ALAIR 2026 Full Conference Program 2026-03-09.pdf" target="_blank" className="red">
              2026 ALAIR Full Conference Program
            </a>
          </h3>
          <h3>
          <a href="/forms/ALAIR 2026 Schedule at a Glance.pdf" target="_blank" className="red">
            2026 ALAIR Conference Schedule at a Glance
          </a>
        </h3>
        </Paper> */}
        {/* <br />Conference location: Southern Union State Community College, Opelika, AL
        <img src="/assets/SUSCC campus-slider1.jpg" alt="Southern Union State Community College" style={{ width: '100%', height: 'auto' }} />
        <p>
          ALAIR 2026 Conference: Growth and Transformation through Institutional Research
          <br />March 11-13, 2026
          <br />
          <hr />
        </p> */}
        {/* <p>
          February 13, 2026 is the deadline for early conference registration, the preferred hotel room block rate, and conference session proposals.  The conference registration fee will increase beginning February 14, 2026.
        </p>
        <br />Preferred hotel: Auburn Marriott Opelika Resort & Spa at Grand National, Opelika, AL
        <img src="/assets/opelika mariott.jpg" alt="Opelika Mariott Hotel" style={{ width: '100%', height: 'auto' }} /> */}
        
        {/* <Paper>
          <Small>
            <p>
              The group rate for the hotel room block at the Marriott at Grand National will be $199/night, plus a $30 resort service charge. <a href="https://app.marriott.com/reslink?id=1768318887617&key=GRP&app=resvlink" target="_blank">Make your reservation.</a>
            </p>
          </Small>
        </Paper> */}
        
        {/* <Photo2 /> */}
      </ImgText>
    </IMGdiv>
    <Paper>
      <LitHead>Conference Resources</LitHead>
      {/* <p>
        Please direct conference schedule and event questions to Jeffrey Guenther (<a href="mailto:Jeffrey.Guenther@athens.edu">Jeffrey.Guenther@athens.edu</a>).  Registration and payment questions can be sent to Dr. Jesse Lowe (<a href="mailto:jdlowe@uab.edu">jdlowe@uab.edu</a>).
      </p> */}
      <div style={{ paddingTop: '1rem' }}>
        {/* <ul>
          <li>
            <a href="/forms/ALAIR Conference Registration Form 2026-02-19.pdf" target="_blank">
              2026 ALAIR Conference Registration Form
            </a>
          </li>
          <li>
            <a href="/forms/ALAIR Membership Registration Form 2026.pdf" target="_blank">
              2026 ALAIR Membership Registration Form
            </a>
          </li>
          <li>
            <a href="/forms/ALAIR Presentation Proposal 2026.pdf" target="_blank">
              2026 ALAIR Conference Presentation Proposal Form
            </a>
          </li>
          <li>
            <a href="/forms/ALAIR 2026 Full Conference Program 2026-03-09.pdf" target="_blank">
              2026 ALAIR Full Conference Program
            </a>
          </li>
          <li>
            <a href="/forms/ALAIR 2026 Schedule at a Glance.pdf" target="_blank">
              2026 ALAIR Conference Schedule at a Glance
            </a>
          </li>
          <li>
            <a href="/forms/ALAIR Vendor Sponsorship Form 2026 Final.pdf" target="_blank">
              2026 ALAIR Vendor Sponsorship Form
            </a>
          </li>
          <li>
            <a href="/forms/ALAIR_W9.pdf" target="_blank">
              2026 ALAIR W-9 Form
            </a>
          </li>
        </ul> */}

        {/* <h4 id="upcomingevents">Upcoming Events</h4>
        <p>
        The AIR Forum 2022 will be conducted in person June 6 - 9, 2022 in Phoenix, AZ. Save the date and register in February 2022 at <a href="https://www.airweb.org/forum/2022/home" target="_blank">https://www.airweb.org/forum/2022/home</a>.
        </p>
        <p>
        Save the Date for SAIR 49: October 1 - 4, 2022 at the Hotel Monteleone in New Orleans, LA.
        </p> */}
        {/* <ul>
          <li><a href="https://app.marriott.com/reslink?id=1768318887617&key=GRP&app=resvlink" target="_blank">Make your hotel reservation</a></li>
        </ul> */}

        <h4 id="stayconnected">Stay Connected</h4>
        <ul>
          <li>
            <a href="https://www.facebook.com/AlabamaAIR/" target="_blank">
              ALAIR on Facebook
            </a>
          </li>
          <li>
            <a href="https://alair.org/listserv/" target="_blank">
              Join the ALAIR Listserv
            </a>
          </li>
        </ul>

        {/*
        <h4 id="conference2020presentations">Conference 2020 Presentations</h4>
        <ul>
          <li>
            <a href="/forms/KEYNOTE-StudentAchievement-Nuria Cuervas.pdf" download>
              KEYNOTE - Student Achievement - Nuria Cuervas
            </a>
          </li>
          <li>
            <a
              href="/forms/Getting Things Done-Andrew Davis.pdf"
              download
            >
              Getting Things Done - Andrew Davis
            </a>
          </li>
          <li>
            <a
              href="/forms/Increasing Retention of Remedial Students-Tamara Jones and Jonathan Broyles.pdf"
              download
            >
              Increasing Retention of Remedial Students - Tamara Jones and Jonathan Broyles
            </a>
          </li>
          <li>
            <a
              href="/forms/PowerBI-Michelle Tin.pdf"
              download
            >
              PowerBI - Michelle Tin
            </a>
          </li>
          <li>
            <a
              href="/forms/SQL Joins-Anran Xing and Michelle Tin.pdf"
              download
            >
              SQL Joins - Anran Xing and Michelle Tin
            </a>
          </li>
          <li>
            <a
              href="/forms/The First Year-Lisa Kimble.pdf"
              download
            >
              The First Year - Lisa Kimble
            </a>
          </li>
        </ul>
        */}
      </div>
    </Paper>
  </Wrapper>
)

const H2 = styled.h2`
  font-size: 2.5em;
  margin-top: 0.5em;
`

const IMGdiv = styled.div`
  padding: 0em 0em 0em 0em;
`

const Small = styled.p`
  font-size: .75em;
`

const ImgText = styled.p`
  font-size: 1rem;
  margin-top: 1rem;
  width: 100%;
`
const LitHead = styled.h3`
  display: inline;
  text-decoration: none;
  background-image: linear-gradient(transparent, transparent),
    linear-gradient(transparent, transparent),
    linear-gradient(-75deg, #07588a, #39cccc);
  /* linear-gradient(-75deg,#07588a,#39cccc) */
  background-repeat: no-repeat;
  background-position: 120%, 122%, 0 130%;
  background-size: 100% 10px;
`
const Paper = styled.div`
  padding: 2em 1em 1em 1em;
  background: rgba(57, 204, 204, 0.2);
  box-shadow: 0 20px 68px rgba(0, 0, 0, 0.05);
`
